

// export const API_URL = "http://localhost:8000";
export const API_URL = "";

// Defaults for graph selection
export const periodstart = 2010; // Year start
export const periodend = 2018; // Year end
export const areascale = 1; // Number of graphs to display across width

export const DEFAULT_LAT = 55.69142309402058;
export const DEFAULT_LNG = -3.7832450866699223;
export const DEFAULT_ZOOM = 5;

export const ZOOM_SHOWLEVEL_2 = 9;
export const ZOOM_SHOWLEVEL_3 = 11;

export const LEVELS = [
    'Local Authority',
    'MSOA/Intermediate',
    'LSOA/Datazone',
]

export const LEVELS_DESCRIPTIVE = [
    'Local Authorities',
    'MSOA/Intermediate Zones',
    'LSOA/Data Zones',
]

export const AREA_STYLE_DEFAULT = {
    fillColor: '#fff', 
    fillOpacity: 0.5,
    weight: 1, 
    color: "#999",
    opacity: 0.7
};

export const AREA_STYLE_MOUSEOVER = {
    weight: 2, 
    color: "#000",
    opacity: 1,
};

export const AREA_STYLE_MOUSEOUT = {
    weight: 1, 
    color: "#999",
    opacity: 0.7,
};

export const AREA_LEVEL_COLOURS = ["#3f51b5", "#9c27b0", "#4caf50"];